import { Component, Injector, ViewEncapsulation } from '@angular/core';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { AppComponentBase } from '@shared/common/app-component-base';
import { EpisodesServiceProxy, EpisodeUsersServiceProxy, TenantServiceProxy } from '@shared/service-proxies/service-proxies';
import { ActivatedRoute } from '@angular/router';
import { BehaviorSubject, mergeMap, map, tap, repeat, merge, shareReplay, switchMap, takeWhile } from 'rxjs';
import { EpisodeGuardService } from '@app/episode-guard.service';

@Component({
    templateUrl: './episode.component.html',
    styleUrls: ['./episode.component.less'],
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    selector: 'episode',
})
export class EpisodeComponent extends AppComponentBase {

    watchedEpisode: boolean = false;
    feedbackRequired: boolean = false;
    refreshed: boolean = false;

    constructor(
        injector: Injector,
        private _episodeService: EpisodesServiceProxy,
        private route: ActivatedRoute,
        private _episodeUserService: EpisodeUsersServiceProxy,
        private _tenantService: TenantServiceProxy,
        private _episodeGuardService: EpisodeGuardService,
    ) {
        super(injector);

        this._streams.subscribe();
    }

    private readonly _episodeIdSubject = new BehaviorSubject<number>(undefined);
    readonly _episodeId$ = this._episodeIdSubject.asObservable().pipe(
        map(() => Number(this.route.snapshot.paramMap.get('id'))),
        tap((currentEpisodeId) => localStorage.setItem("currentEpisode", currentEpisodeId.toString())),
        shareReplay(1),
    )

    get episodeId() {
        return this._episodeIdSubject.value;
    }

    readonly _episode$ = this._episodeId$.pipe(
        mergeMap((episodeId) => this._episodeService.getEpisodeForView(episodeId)),
        map((episodeDto) => episodeDto.episode),
    )

    readonly _currentEpisodeUser$ = this._episodeId$.pipe(
        switchMap((episodeId) =>
            this._episodeUserService.getCurrentEpisodeUser(episodeId).pipe(
                repeat({ delay: 1000 }),
                takeWhile(user => !user?.hasWatched, true),
            )
        ),
        shareReplay({ bufferSize: 1, refCount: true }),
    )

    readonly _checkWatchedEpisode$ = this._currentEpisodeUser$.pipe(
        tap((currentEpisodeUser) => {
            this.watchedEpisode = currentEpisodeUser?.hasWatched ?? false;
        }),
    )

    reload(): void {
        location.reload();
    }

    private readonly _feedBackRequiredForTenantSubject = new BehaviorSubject<Boolean>(undefined);
    readonly _feedBackRequiredForTenant$ = this._feedBackRequiredForTenantSubject.asObservable().pipe(
        mergeMap(() => this._tenantService.isFeedBackRequiredForTenant()),
        tap((x) => {
            if (x.isFeedbackRequired) {
                this.nextEpisodeLogic();
                this.feedbackRequired = true;
            }
        })
    )

    nextEpisodeLogic(): void {
        this._episodeGuardService.nextEpisode();
    }

    onRatingSubmitted(rating: number): void {
        // Rating saved; _currentEpisodeUser$ polling will update the component state
    }

    private readonly _streams = merge(
        this._feedBackRequiredForTenant$,
        this._checkWatchedEpisode$
    )
}
